const hasPlatformStorage = (): boolean => {
  return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
};

const getStorageNamespace = (): string => {
  if (typeof window === "undefined" || !window.location?.hostname) {
    return "switch:default";
  }
  const host = window.location.hostname.toLowerCase().replace(/[^a-z0-9.-]/g, "_");
  return `switch:${host}`;
};

const namespacedKey = (key: string): string => `${getStorageNamespace()}:${key}`;

export const getPlatformStorageItem = (key: string): string | null => {
  if (!hasPlatformStorage()) return null;
  try {
    const scoped = window.localStorage.getItem(namespacedKey(key));
    if (scoped !== null) return scoped;
    // Legacy fallback for pre-namespace clients.
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
};

export const setPlatformStorageItem = (key: string, value: string): void => {
  if (!hasPlatformStorage()) return;
  try {
    window.localStorage.setItem(namespacedKey(key), value);
  } catch {
    // ignore storage failures (e.g., disabled storage)
  }
};

export const removePlatformStorageItem = (key: string): void => {
  if (!hasPlatformStorage()) return;
  try {
    window.localStorage.removeItem(namespacedKey(key));
    // Legacy cleanup for pre-namespace clients.
    window.localStorage.removeItem(key);
  } catch {
    // ignore storage failures (e.g., disabled storage)
  }
};
